<template>
	<div class="courses" :class="{ 'dark-theme': isDarkMode }">
		<div class="container">
			<h1>Szkolenia AI</h1>

			<section class="intro">
				<p>
					Oferujemy praktyczne warsztaty z zakresu sztucznej inteligencji (AI), które pomogą Twojej firmie lub
					zespołowi skutecznie wdrażać nowoczesne technologie.
					Nasze szkolenia są dostosowane do różnych poziomów zaawansowania – od podstaw po zaawansowane
					techniki automatyzacji procesów.
				</p>
			</section>

			<section class="details">
				<h2>Co zyskasz dzięki naszym szkoleniom?</h2>
				<ul>
					<li><strong>Praktyczna wiedza:</strong> Nauczysz się stosować AI w codziennej pracy.</li>
					<li><strong>Indywidualne podejście:</strong> Szkolenia dostosowane do potrzeb Twojej organizacji.
					</li>
					<li><strong>Eksperci branżowi:</strong> Prowadzący z doświadczeniem w AI i IT.</li>
					<li><strong>Certyfikaty:</strong> Potwierdzenie zdobytej wiedzy po zakończeniu kursu.</li>
				</ul>
			</section>

			<section class="features">
				<h2>Zakres tematyczny</h2>
				<div class="feature-list">
					<div v-for="course in courses" :key="course.slug" class="feature-item">
						<h3>{{ course.title }}</h3>
						<h4>{{ course.subtitle }}</h4>
						<p>{{ course.description }}</p>
						<div class="feature-buttons">
							<button class="feature-btn blue" @click="goToCourse(course.slug)">Szczegóły</button>
							<button class="feature-btn red" @click="goToContact">Zapisz się</button>
						</div>

					</div>
				</div>
			</section>

			<section class="consulting-cta">
				<h2>Potrzebujesz indywidualnego podejścia?</h2>
				<p>
					Nasz specjalista pomoże Ci w nauce i wdrożeniu AI w Twojej firmie – od strategii po praktyczne
					rozwiązania.
					Skorzystaj z naszych usług konsultingowych i osiągnij sukces z AI!
				</p>
				<div class="buttons">
					<button class="cta-btn" @click="goToContact">Zapisz się na szkolenie</button>
					<button class="consulting-btn" @click="goToConsulting">Dowiedz się więcej o konsultingu AI</button>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
export default {
	inject: ['theme'],
	data() {
		return {
			courses: [
				{
					slug: 'wprowadzenie-ai',
					title: 'Wprowadzenie do AI',
					subtitle: 'Fundamenty, które każdy powinien znać',
					description: 'Poznasz podstawy działania sztucznej inteligencji i jak ją wykorzystać w codziennej pracy.'
				},
				{
					slug: 'canva-ai',
					title: 'Canva & AI',
					subtitle: 'Tworzenie treści wizualnych wspomagane sztuczną inteligencją',
					description: 'Praktyczne warsztaty z projektowania grafiki i materiałów edukacyjnych z pomocą AI – idealne dla nauczycieli.'
				},
				{
					slug: 'audio-video-ai',
					title: 'Dźwięk i Wideo z AI',
					subtitle: 'Nowoczesne multimedia bez wysiłku',
					description: 'Dowiesz się, jak tworzyć podcasty, nagrania i filmy edukacyjne wykorzystując sztuczną inteligencję.'
				},
			]
		};
	},
	computed: {
		isDarkMode() {
			return this.theme.isDarkMode;
		}
	},
	methods: {
		goToContact() {
			this.$router.push('/contact');
		},
		goToConsulting() {
			this.$router.push('/consulting');
		},
		goToCourse(slug) {
			this.$router.push(`/courses/${slug}`);
		}
	}
};
</script>

<style scoped>
.courses {
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: center;
	transition: all 0.3s ease;
}

.courses:not(.dark-theme) {
	background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%);
	color: #1f2937;
}

.courses.dark-theme {
	background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
	color: #f9fafb;
}

.container {
	max-width: 1200px;
	margin: 0 auto;
	padding: 40px 20px;
}

h1 {
	font-size: 2.5rem;
	color: #ff0000;
	text-align: center;
	margin-bottom: 30px;
}

.intro p {
	font-size: 1.2rem;
	line-height: 1.8;
	text-align: center;
	margin-bottom: 40px;
}

.details {
	margin-bottom: 40px;
}

.details h2 {
	font-size: 1.8rem;
	color: #00b4d8;
	margin-bottom: 20px;
	text-align: center;
}

.details ul {
	list-style: none;
	padding: 0;
}

.details li {
	font-size: 1.1rem;
	line-height: 1.6;
	margin-bottom: 15px;
}

.details li strong {
	color: #00b4d8;
}

.features {
	margin-bottom: 40px;
}

.features h2 {
	font-size: 1.8rem;
	color: #ff0000;
	margin-bottom: 20px;
	text-align: center;
}

.feature-list {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
	gap: 20px;
}

.feature-item {
	background: #fff;
	border-radius: 12px;
	padding: 20px;
	box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
	transition: transform 0.3s ease;
}

.dark-theme .feature-item {
	background: #2d2d2d;
}

.feature-item:hover {
	transform: translateY(-5px);
}

.feature-item h3 {
	font-size: 1.3rem;
	color: #00b4d8;
	margin-bottom: 10px;
}

.feature-item h4 {
	font-size: 1rem;
	color: #6b7280;
	margin-bottom: 10px;
}

.feature-item p {
	font-size: 1rem;
	color: #6b7280;
	margin-bottom: 10px;
}

.feature-buttons {
	display: flex;
	gap: 10px;
	justify-content: center;
	margin-top: 10px;
}

.feature-btn {
	padding: 8px 16px;
	border-radius: 8px;
	border: none;
	cursor: pointer;
	transition: transform 0.3s ease;
	font-size: 1rem;
	color: #fff;
}

.feature-btn.red {
	background: #ff0000;
}

.feature-btn.red:hover {
	background: #cc0000;
	transform: scale(1.05);
}

.feature-btn.blue {
	background: #00b4d8;
}

.feature-btn.blue:hover {
	background: #008cb2;
	transform: scale(1.05);
}


.dark-theme .feature-detail-btn {
	color: #ff0000;
	border-color: #ff0000;
}

.dark-theme .feature-detail-btn:hover {
	background: #ff0000;
	color: #fff;
}

.consulting-cta {
	margin-bottom: 40px;
	text-align: center;
}

.consulting-cta h2 {
	font-size: 1.8rem;
	color: #00b4d8;
	margin-bottom: 15px;
}

.consulting-cta p {
	font-size: 1.1rem;
	line-height: 1.6;
	margin-bottom: 20px;
}

.buttons {
	display: flex;
	justify-content: center;
	gap: 20px;
}

.consulting-btn {
	background: linear-gradient(90deg, #00b4d8, #ff0000);
	color: #fff;
	padding: 10px 20px;
	border: none;
	border-radius: 8px;
	font-size: 1.1rem;
	cursor: pointer;
	transition: transform 0.3s ease;
}

.consulting-btn:hover {
	transform: scale(1.05);
}

.cta-btn {
	background: linear-gradient(90deg, #ff0000, #00b4d8);
	color: #fff;
	padding: 12px 24px;
	border: none;
	border-radius: 8px;
	font-size: 1.2rem;
	cursor: pointer;
	transition: transform 0.3s ease;
}

.cta-btn:hover {
	transform: scale(1.05);
}

@media (max-width: 768px) {
	h1 {
		font-size: 2rem;
	}

	.intro p {
		font-size: 1rem;
	}

	.details h2,
	.features h2,
	.consulting-cta h2 {
		font-size: 1.5rem;
	}

	.details li,
	.feature-item p,
	.consulting-cta p {
		font-size: 1rem;
	}

	.feature-item h3 {
		font-size: 1.2rem;
	}

	.buttons {
		flex-direction: column;
		gap: 15px;
	}
}
</style>
